export { default as crackImg } from './crack.svg';
export { default as hitImg } from './hit.svg';
export { default as liabilityImg } from './liability.svg';
export { default as roadsideAssistanceImg } from './roadside-assistance.svg';
export { default as theftImg } from './theft.svg';
export { default as unexpectedImg } from './unexpected.svg';
export { default as liabilityPpmImg } from './ppm/liability.svg';
export { default as hitPpmImg } from './ppm/hit.svg';
export { default as roadsideAssistancePpmImg } from './ppm/roadside-assistance.svg';
export { default as roadsideAssistancePpmImg2 } from './ppm/roadside-assistance2.svg';
export { default as unexpectedPpmImg } from './ppm/unexpected.svg';
export { default as theftPpmtImg } from './ppm/theft.svg';
